export const DateToHumanDate = (date = null, region = 'en') => {
  if (!date) return null;

  const formatted = Intl.DateTimeFormat(region, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false,
  }).format(new Date(date));

  return formatted;
};

export const DateToShortDateTime = (date = null, region = 'en') => {
  if (!date) return null;

  const formatted = Intl.DateTimeFormat(region, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
  }).format(new Date(date));

  return formatted;
};

export const dateAsTitle = (date) => {
  const currDate = date ? new Date(date) : new Date();
  const result = `${currDate.getFullYear()}-${currDate.getMonth()}-${currDate.getDate()}_${currDate.getHours()}-${currDate.getMinutes()}-${currDate.getSeconds()}`;
  return result;
};
